const alphalinkDataRecharge = {
  product: {
    label: "Produit correspondant"
  },
  quantity: {
    label: "Quantité"
  },
  alphalinkMobileProductGroup: {
    label: "Groupe Alphalink",
    allowMoreField: {
      addLabel: "Ajouter",
      removeLabel: "Enlever",
      removingLabel: "Supprimer"
    }
  },
  alphalinkOfferDataOption: {
    label: "Recharge Alphalink"
  }
};

export default alphalinkDataRecharge;
